<div
    style="background-color: white; width: 100%; max-width: 538px; height: auto; display: flex; flex-direction: column; align-items: center; padding: 12px 16px 32px 16px;">

    <div style="width: 100%; display: flex; justify-content: flex-end;">
        <img (click)="closeDialog()" onKeyDown="" src="../../../assets/icons/gray_close.svg" alt=""
            style="width: 16px; height: 16px; cursor: pointer;">
    </div>

    <!-- Si mostrarBtnOK es diferente true, muestra el icono de check -->
    <i *ngIf="!data.mostrarBtnOK" class="fa-regular fa-circle-check"
        style="font-size: 32px; color: green; margin: 17px 0 16px 0;">
    </i>

    <!-- Si mostrarBtnOK es true, muestra la imagen de interrogacion -->

   <!-- <i *ngIf="data.mostrarBtnOK" class="fa-regular fa-circle-question"
        style="font-size: 32px; color: green; margin: 17px 0 16px 0;">
    </i>-->

     <i *ngIf="data.mostrarBtnOK" class="fa-solid fa-circle-exclamation fs-40px mb-4"
        style="font-size: 32px; color: gold; margin: 17px 0 16px 0;">
    </i>

    <p class="info-title" style="white-space: pre-line;"[innerHTML]="mensaje"></p>

    <button *ngIf="!data.mostrarBtnOK" (click)="closeDialog()" class="btn btn-success">
        Continuar
    </button>

    <div *ngIf="data.mostrarBtnOK" style="display: flex; gap: 10px; justify-content: center;">
        <button (click)="closeDialog()" class="btn btn-secondary">
            Cancelar
        </button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button (click)="save()" class="btn btn-primary">
            {{labelBtnOK}}
        </button>

    </div>
</div>